export default "__VITE_PUBLIC_ASSET__f8f3bef1__"